import axios from 'axios';

export interface Permission {
  id: number;
  name: string;
  value: string;
  createdAt: string;
  updatedAt: string;
}

// Usar variável de ambiente
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`;
const PERMISSIONS_ENDPOINT = '/permissions';

export class PermissionService {
  async getAll(): Promise<Permission[]> {
    // Usar a URL completa
    const response = await axios.get<Permission[]>(`${API_BASE_URL}${PERMISSIONS_ENDPOINT}`);
    return response.data;
  }

  async getById(id: number): Promise<Permission> {
    // Usar a URL completa
    const response = await axios.get<Permission>(`${API_BASE_URL}${PERMISSIONS_ENDPOINT}/${id}`);
    return response.data;
  }
} 